/** @jsxImportSource @emotion/react */
import { Button, css, SxProps } from "@mui/material";
import { ReactNode } from "react";

interface DownloadButtonProps {
    children: ReactNode;
    onClick: () => void;
    sx?: SxProps;
}

const DownloadButton = ({ onClick, children, sx }: DownloadButtonProps) => {

    return <Button
        variant="contained"
        css={css`
                  padding: 8px 22px;
                  border-radius: 4px;
                  font-size: 14px;
                  font-weight: 600;
                  text-transform: none;
                  display: flex;
                  align-items: center;
                  gap: 8px;
                  background: #fff;
                  color: #3F906D;
                  border: 1px solid #3F906D;
                  &:hover {
                    background: #3F906D;
                    color: #fff;
                    svg {
                      * {
                        stroke: #fff;
                      }
                    }
                  }
                  svg {
                    * {
                      stroke: #3F906D;
                    }
                  }
                `}
        sx={sx}
        onClick={onClick}
    >
        {children}
    </Button>
}

export default DownloadButton;